import { ContentContainer, ScrollableDialog } from '../../components/dialogs/CustomDialog'
import { Linking, TouchableOpacity, View } from 'react-native'
import NormalIcon from '../../components/icons/NormalIcon'
import IconNames from '../../constants/IconNames'
import Colors from '../../constants/Colors'
import { CustomText } from '../../components/text/StyledText'
import { txt } from '../../locales/i18n'
import { ButtonPrimary } from '../../components/buttons/StyledButtons'
import React from 'react'

export default function ShareStoryDialog({ visible, close }) {
	return (
	<ScrollableDialog visible={visible} style={{ maxWidth: 500 }}>
		<ContentContainer>
			<TouchableOpacity
				style={{ alignSelf: 'flex-end', position: 'absolute', paddingLeft: 24, zIndex: 1 }}
				accessibilityRole="button"
				onPress={close}
			>
				<NormalIcon name={IconNames.close} color={Colors.inactive} />
			</TouchableOpacity>
				
			<CustomText font="bold" style={{ fontSize: 20, fontFamily: 'raleway-semibold' }}>
				{txt('learnDanish.user.shareStoryDialog.title')}
			</CustomText>
			<CustomText style={{ marginTop: 12 }}>
				{txt('learnDanish.user.shareStoryDialog.text1')}
				<CustomText
					onPress={() => Linking.openURL('mailto:sprogland@rodekors.dk')}
					style={{ color: Colors.blueAzure }}
				>
					{txt('learnDanish.user.shareStoryDialog.email')}
				</CustomText>
				{txt('learnDanish.user.shareStoryDialog.text2')}	
			</CustomText>
				
		</ContentContainer>
		<View style={{ paddingBottom: 16 }}>
			<ButtonPrimary
				onPress={close}
				style={{ backgroundColor: Colors.blueAzure }}
				title={txt('global.close')}
				titleStyle={{ paddingHorizontal: 12 }}
			/>
		</View>
	</ScrollableDialog>
	)
}
